import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { doLogout, getUser, isLoggedIn } from "../services/user-service";

// export const Userroute = () => {
// //     return getUser().role=="USER" ? <Outlet /> : <Navigate to={"/"} />
// // };
//
// const user = getUser();
//
//   // Allow normal USER + ORG_USER (PRIMARY only)
//   if (
//     user.role === "USER" ||
//     (user.role === "ORG_USER" && user.accountType === "primary")
//   ) {
//     return <Outlet />;
//   }
// };
export const Userroute = () => {
  const user = getUser();

  if (!user) {
    return <Navigate to="/" />;
  }

  // ✅ Allow both independent USER and ORG_USER to use /user routes
  if (user.role === "USER" || user.role === "ORG_USER") {
    return <Outlet />;
  }

  // Anything else gets kicked out
  return <Navigate to="/" />;
};


export const Trusteeroute = () => {

    return getUser().role=="ATTORNEY" ? <Outlet /> : <Navigate to={"/"} />
};

export const Beneficiryroute = () => {

    return getUser().role=="BENEFICIARY" ? <Outlet /> : <Navigate to={"/"} />
};

// export const TenantAdminRoute = () => {
//   return getUser().role === "TENANT_ADMIN" ? <Outlet /> : <Navigate to="/" />;
// };

// export const TenantAdminRoute = () => {
//   const role = getUser().role;
// //   return (role === "TENANT_ADMIN" || role === "ORG_USER")
//       return role === "TENANT_ADMIN"
//     ? <Outlet />
//     : <Navigate to="/" />;
// };
export const TenantAdminRoute = () => {
  const user = getUser();

  if (!user) {
    return <Navigate to="/" />;
  }

  // Allow both Tenant Admin and Tenant User
  if (user.role === "TENANT_ADMIN" || user.role === "TENANT_USER") {
    return <Outlet />;
  }

  // Block all others
  return <Navigate to="/" />;
};
